import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type ExerciseIconProps = Partial<SVGIconProps>;

/** Dumbbell glyph copied from the mobile Exercise home card icon pack. */
const ExerciseIcon: FC<ExerciseIconProps> = (props) => (
  <SVGIcon viewBox="0 0 24 24" {...props}>
    <path
      d="M16 8C15.8863 8.35636 15.6976 8.68424 15.4467 8.9616C15.1957 9.23896 14.8883 9.45937 14.545 9.608C12.2643 10.618 10.6187 12.2637 9.608 14.545C9.45937 14.8883 9.23896 15.1957 8.9616 15.4467C8.68424 15.6976 8.35636 15.8863 8 16"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
    <path
      d="M3.2 20.8L2 22M20.8 3.2L22 2M17.788 2.422L16.276 3.875L20.116 7.752L21.594 6.317C22.038 5.795 22.174 5.401 21.621 4.677L20.516 3.513L19.395 2.407C18.678 1.765 18.114 2.111 17.788 2.422Z"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
    <path
      d="M14.012 3.75802C15.122 2.58402 15.882 3.41902 16.273 3.88402L20.081 7.70702C20.555 8.08702 21.421 8.81702 20.276 9.95102C20.091 10.134 19.91 10.326 19.709 10.491C18.967 11.101 18.255 10.596 17.878 10.131L14.002 6.25502C13.594 5.88902 12.889 5.22502 13.484 4.33702C13.644 4.13202 13.833 3.94702 14.011 3.75702M4.58697 21.62L3.44697 20.492L2.36197 19.35C1.71897 18.707 2.08997 18.063 2.40797 17.744L3.88997 16.26L7.74597 20.134L6.22797 21.624C5.69797 22.058 5.33297 22.191 4.61997 21.624M6.22297 13.924C5.83297 13.459 5.07297 12.624 3.96097 13.798C3.78297 13.987 3.59497 14.172 3.43397 14.377C2.83897 15.265 3.54397 15.929 3.95197 16.295L7.82797 20.171C8.20497 20.636 8.91697 21.141 9.65797 20.531C9.85997 20.366 10.041 20.174 10.226 19.991C11.372 18.856 10.505 18.127 10.031 17.747L6.22297 13.924Z"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </SVGIcon>
);

export default ExerciseIcon;
